export function transformToPascal(x: string) {
  return x.charAt(0).toUpperCase() + x.slice(1).toLowerCase();
}

export function capitalize(x: string) {
  return x.charAt(0).toUpperCase() + x.slice(1);
}
